/* eslint-disable no-trailing-spaces */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TabsPage } from './tabs.page';
const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'menu',
        loadChildren: () => import('../order/order.module').then(m => m.OrderPageModule)
      },
      {
        path: 'menu?:type&table',
        loadChildren: () => import('../order/order.module').then(m => m.OrderPageModule)
      },

      {

        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'rewards',
        loadChildren: () => import('../offers/offers.module').then(m => m.OffersPageModule)
      },
      {
        path: 'gift-card',
        loadChildren: () => import('../gift-cards/gift-cards.module').then(m => m.GiftCardsPageModule)
      },
      {
        path: 'new-cart',
        loadChildren: () => import('../new-cart/new-cart.module').then(m => m.NewCartPageModule)
      },
      {
        path: 'recent-fav',
        loadChildren: () => import('../recent-fav/recent-fav.module').then(m => m.RecentFavPageModule)
      },
      {
        path: 'more',
        loadChildren: () => import('../more/more.module').then(m => m.MorePageModule)
      }
    ]
  },

  {
    path: '',
    redirectTo: 'tabs/menu',

  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
